import React, { useEffect, useState } from "react";
import { AccessLogLoadingDialog } from "./accessLog-loading-dialog/AccessLogLoadingDialog";
import { AccessLogCard } from "./AccessLogCard";
import { AccessLogUIProvider } from "./AccessLogUIContext";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { accessLogListApi } from "../../../axios/services/services";
import ErrorModal from "../Modal/ErrorModal";
import { initialFilter } from "./AccessLogUIHelpers";
import { isUnauthorized, trimmer } from "../../utils/utils";

export function AccessLogPage({ history }) {
  const [data, setData] = useState({});
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [accessLogList, setAccessLogList] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [accessLogListTotalCount, setAccessLogListTotalCount] = useState(0);
  const [filterValues, setFilterValues] = useState({});
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const accessLogUIEvents = {
    openReceiptDialog: (row) => {
      setData(row);
    },
    openDeleteDialog: (row) => {
      setData(row);
    },
  };

  useEffect(() => {
    async function getAccessLogList() {
      enableLoading();
      const accessLogListResponse = await accessLogListApi(
        trimmer({
          filterValues,
          queryParams,
        })
      );
      disableLoading();

      if (accessLogListResponse.Error) {
        isUnauthorized({ response: accessLogListResponse });
        setErrorMessage(accessLogListResponse.Error.message);
        handleErrorModalShow();
        return;
      }
      setAccessLogListTotalCount(
        accessLogListResponse && accessLogListResponse.count
          ? accessLogListResponse.count
          : 0
      );
      setAccessLogList(
        accessLogListResponse && accessLogListResponse.data
          ? accessLogListResponse.data
          : []
      );
    }
    getAccessLogList();
  }, [filterValues, queryParams]);

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const handleErrorModalShow = () => {
    setIsErrorModalOpen(true);
  };

  const handleErrorModalHide = () => {
    setIsErrorModalOpen(false);
  };

  const handleFilterValues = (values) => {
    setFilterValues(values);
  };

  const handleSetCurrentPage = (currentPage) => {
    setCurrentPage(currentPage);
  };

  return (
    <AccessLogUIProvider
      accessLogUIEvents={accessLogUIEvents}
      queryParams={queryParams}
      setQueryParamsBase={setQueryParamsBase}
      ids={ids}
      setIds={setIds}
    >
      <AccessLogLoadingDialog />

      <AccessLogCard
        isLoading={isLoading}
        filterValues={filterValues}
        handleFilterValues={handleFilterValues}
        // handleAddAccessLogShow={handleAddAccessLogShow}
        accessLogListTotalCount={accessLogListTotalCount}
        currentPage={currentPage}
        setCurrentPage={handleSetCurrentPage}
        accessLogList={accessLogList}
      />

      <ErrorModal
        message={errorMessage}
        isErrorModalOpen={isErrorModalOpen}
        hideErrorModal={handleErrorModalHide}
        errorIcon={
          <div className="danger-icon-wrapper text-center">
            <span className="svg-icon menu-icon svg-icon-white svg-icon-4x mr-0">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Navigation/Close.svg")}
              />
            </span>
          </div>
        }
        errorButtonLabel={"Close"}
        errorOnClick={handleErrorModalHide}
      />
    </AccessLogUIProvider>
  );
}
